'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataPurchaseOrderForm(number, recipient, currency, lineItems, documentaryCredit, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, importer, consignee, harmonizedSystemCode) {
  this.iZ = null;
  this.j0 = null;
  this.ix = null;
  this.iY = null;
  this.jq = null;
  this.jw = null;
  this.jv = null;
  this.jt = null;
  this.ju = null;
  this.js = null;
  this.jp = null;
  this.jr = null;
  this.iZ = number;
  this.j0 = recipient;
  this.ix = currency;
  this.iY = lineItems;
  this.jq = documentaryCredit;
  this.jw = placeOfReceipt;
  this.jv = placeOfLoading;
  this.jt = placeOfDelivery;
  this.ju = placeOfDischarge;
  this.js = importer;
  this.jp = consignee;
  this.jr = harmonizedSystemCode;
}
export { $c_Lapp_data_AppDocumentDataPurchaseOrderForm as $c_Lapp_data_AppDocumentDataPurchaseOrderForm };
$p = $c_Lapp_data_AppDocumentDataPurchaseOrderForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataPurchaseOrderForm;
/** @constructor */
function $h_Lapp_data_AppDocumentDataPurchaseOrderForm() {
}
export { $h_Lapp_data_AppDocumentDataPurchaseOrderForm as $h_Lapp_data_AppDocumentDataPurchaseOrderForm };
$h_Lapp_data_AppDocumentDataPurchaseOrderForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataPurchaseOrderForm)) {
    if ((this.iZ === x$0.iZ)) {
      var x = this.j0;
      var x$2 = x$0.j0;
      var $x_10 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$3 = this.ix;
      var x$4 = x$0.ix;
      var $x_9 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$5 = this.iY;
      var x$6 = x$0.iY;
      var $x_8 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$7 = this.jq;
      var x$8 = x$0.jq;
      var $x_7 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$9 = this.jw;
      var x$10 = x$0.jw;
      var $x_6 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$11 = this.jv;
      var x$12 = x$0.jv;
      var $x_5 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$13 = this.jt;
      var x$14 = x$0.jt;
      var $x_4 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$15 = this.ju;
      var x$16 = x$0.ju;
      var $x_3 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$17 = this.js;
      var x$18 = x$0.js;
      var $x_2 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$19 = this.jp;
      var x$20 = x$0.jp;
      var $x_1 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$21 = this.jr;
      var x$22 = x$0.jr;
      return ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 12;
});
$p.t = (function() {
  return "AppDocumentDataPurchaseOrderForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.iZ;
      break;
    }
    case 1: {
      return this.j0;
      break;
    }
    case 2: {
      return this.ix;
      break;
    }
    case 3: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.iY);
      break;
    }
    case 4: {
      return this.jq;
      break;
    }
    case 5: {
      return this.jw;
      break;
    }
    case 6: {
      return this.jv;
      break;
    }
    case 7: {
      return this.jt;
      break;
    }
    case 8: {
      return this.ju;
      break;
    }
    case 9: {
      return this.js;
      break;
    }
    case 10: {
      return this.jp;
      break;
    }
    case 11: {
      return this.jr;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "recipient";
      break;
    }
    case 2: {
      return "currency";
      break;
    }
    case 3: {
      return "lineItems";
      break;
    }
    case 4: {
      return "documentaryCredit";
      break;
    }
    case 5: {
      return "placeOfReceipt";
      break;
    }
    case 6: {
      return "placeOfLoading";
      break;
    }
    case 7: {
      return "placeOfDelivery";
      break;
    }
    case 8: {
      return "placeOfDischarge";
      break;
    }
    case 9: {
      return "importer";
      break;
    }
    case 10: {
      return "consignee";
      break;
    }
    case 11: {
      return "harmonizedSystemCode";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentDataPurchaseOrderForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j1)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataPurchaseOrderForm as $isArrayOf_Lapp_data_AppDocumentDataPurchaseOrderForm };
var $d_Lapp_data_AppDocumentDataPurchaseOrderForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataPurchaseOrderForm, "app.data.AppDocumentDataPurchaseOrderForm", ({
  j1: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataPurchaseOrderForm as $d_Lapp_data_AppDocumentDataPurchaseOrderForm };
//# sourceMappingURL=app.data.-App-Document-Data-Purchase-Order-Form.js.map
